export const SET_FILTRO_LISTAGEM_USUARIO_MODULO_FAZENDA =
    'SET_FILTRO_LISTAGEM_USUARIO_MODULO_FAZENDA'

export const setFiltroListagem = (filtroListagem) => ({
    type: SET_FILTRO_LISTAGEM_USUARIO_MODULO_FAZENDA,
    filtroListagem,
})
